import React from 'react';
import { withTranslation } from 'react-i18next/hooks';

import theme from '../../../theme';

import {Button, ButtonGroup} from '@material-ui/core';

class TabbedMenu_ extends React.Component{

  handleClick(tab){
    if(this.props.onClick) 
    this.props.onClick(tab)
  }

  buttonStyle(name){
    const buttonStyle = {
      minWidth: '100px',
      minHeight: '2.0em',
      background: theme.palette.background.tabbedMenu,
      color: theme.palette.color.tabbedMenu
    } 
    if(this.props.selected===name){
      return {
        ...buttonStyle,
        background: theme.palette.background.tabbedMenuSelected
      }
    }else{
      return buttonStyle
    }

  }

  render(){
    const {t} = this.props

    const buttonDispatchers = true || this.props.dispatchersEnabled?(
      <Button style={this.buttonStyle('dispatchers')} 
        onClick={()=>this.handleClick('dispatchers')}>{t('Dispatchers')}</Button>
    ):'';
    const buttonCustom = true || this.props.customEnabled?(
      <Button style={this.buttonStyle('custom')} 
        onClick={()=>this.handleClick('custom')}>{t('Custom')}</Button>
    ):'';
    const buttonDeviceDefaults = true || this.props.deviceDefaultsEnabled?(
      <Button style={this.buttonStyle('device_defaults')} 
        onClick={()=>this.handleClick('device_defaults')}>{t('DeviceDefaults')}</Button>
    ):'';
    const buttonApi = true || this.props.apiEnabled?(
      <Button style={this.buttonStyle('api')} 
        onClick={()=>this.handleClick('api')}>{t('API')}</Button>
    ):'';
    const buttonDmr = this.props.dmrEnabled?(
      <Button style={this.buttonStyle('dmr')} 
        onClick={()=>this.handleClick('dmr')}>{t('DMR')}</Button>
    ):'';
    const buttonSystemMonitoring = true || this.props.monitoringEnabled?(
      <Button style={this.buttonStyle('system_monitoring')} 
        onClick={()=>this.handleClick('system_monitoring')}>{t('SystemMonitoring')}</Button>
    ):'';
    const buttonFieldTemplates = true || this.props.templatesEnabled?(
        <Button style={this.buttonStyle('field_templates')} 
          onClick={()=>this.handleClick('field_templates')}>{t('FieldTemplates')}</Button>
      ):'';

    return (
      <ButtonGroup size="small">
        {buttonDispatchers}
        {buttonCustom}
        {buttonDeviceDefaults}
        {buttonApi}
        {buttonDmr}
        {buttonSystemMonitoring}
        {buttonFieldTemplates}
      </ButtonGroup>
    );
  }
}

export const TabbedMenu = withTranslation()(TabbedMenu_);